import axios from "axios";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const localDate = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ihmj_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  cfg.headers["X-Local-Date"] = localDate();
  return cfg;
});
